export function Wordmark({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`wordmark ${compact ? "wordmark--compact" : ""}`} aria-label="VEIL">
      {!compact && <span className="wordmark__kicker">A game of big bluffs</span>}
      <span className="wordmark__title">
        <b>VEIL</b>
      </span>
      {!compact && <span className="wordmark__motto">Lie. Doubt. Survive.</span>}
    </div>
  );
}
